import classNames from 'classnames';
import React from 'react';
import Loader from './Loader';
import styles from './LoaderOverlay.scss';
var LoaderOverlay = function (props) { return (React.createElement("div", { className: styles.container, "data-hook": "loader-overlay" },
    React.createElement("div", { className: classNames(styles.overlay, props.className) }),
    React.createElement(Loader, { className: styles.spinner, size: props.size }))); };
export default LoaderOverlay;
//# sourceMappingURL=LoaderOverlay.js.map